module.exports = {"230225100":"甘南镇","230225101":"兴十四镇","230225102":"平阳镇","230225103":"东阳镇","230225104":"巨宝镇","230225201":"长山乡","230225202":"中兴乡","230225203":"兴隆乡","230225204":"宝山乡","230225206":"查哈阳乡","230225500":"查哈阳农场","230225580":"北京市双河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230225.json
// module id = 789
// module chunks = 0